<!-- Select Type (Custom Dropdown with Select-like behavior) -->
<div *ngIf="filterType === 'select'" class="dropdown-container select-type" [class.is-open]="isDropdownOpen" [class.has-selection]="multipleSelection ? selectedItems.length > 0 : !!selectedItem" [style.width]="width">
  <div
    class="dropdown-trigger"
    tabindex="0"
    role="button"
    (click)="toggleDropdown(); $event.stopPropagation()"
    (focus)="onTriggerFocus()"
    (mousedown)="onTriggerMouseDown()"
    (keydown)="onTriggerKeydown($event)"
  >
    <!-- Search input in trigger: only for single-select searchable -->
    <input
      *ngIf="searchable && isDropdownOpen && !multipleSelection"
      #searchInput
      class="dropdown-search-input"
      [value]="searchText"
      [placeholder]="selectedItem ? getDisplayText(selectedItem) : placeholder"
      (input)="onSearchInput($event)"
      (click)="$event.stopPropagation()"
      (keydown)="onSearchInputKeydown($event)"
    />
    <!-- Single-select text (when not in search mode) -->
    <span *ngIf="!multipleSelection && (!searchable || !isDropdownOpen)"
          class="dropdown-text"
          [title]="selectedItem || placeholder">
      {{ selectedItem ? getDisplayText(selectedItem) : getDisplayText(placeholder) }}
    </span>
    <!-- Multi-select with 0–1 items: show text (original behavior) -->
    <span *ngIf="multipleSelection && selectedItems.length <= 1 && !showRemoveBadge"
          class="dropdown-text"
          [title]="getMultiDisplayText()">
      {{ getMultiDisplayText() }}
    </span>
    <!-- Multi-select with 2+ items: render badges without X (original behavior) -->
    <div *ngIf="multipleSelection && selectedItems.length > 1 && !showRemoveBadge"
         class="multi-badges-container">
      <span *ngFor="let selItem of selectedItems" class="multi-badge-pill">{{ getDisplayText(selItem) }}</span>
    </div>
    <!-- showRemoveBadge: placeholder when nothing selected -->
    <span *ngIf="multipleSelection && selectedItems.length === 0 && showRemoveBadge"
          class="dropdown-text"
          [title]="placeholder">
      {{ getDisplayText(placeholder) }}
    </span>
    <!-- showRemoveBadge: all selected items as badges with × -->
    <div *ngIf="multipleSelection && selectedItems.length > 0 && showRemoveBadge"
         class="multi-badges-container">
      <span *ngFor="let selItem of selectedItems" class="multi-badge-pill">
        {{ getDisplayText(selItem) }}
        <span class="badge-remove-btn" (click)="removeBadgeItem(selItem, $event)">×</span>
      </span>
    </div>
    <svg
      class="dropdown-icon"
      [class.open]="isDropdownOpen"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L6 6.5L11 1.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div #selectMenu class="dropdown-menu" [style.background]="backGround"
        [class.open]="isDropdownOpen" [class.align-right]="alignRight">
    <!-- Search input inside menu for multi-select searchable -->
    <input
      *ngIf="searchable && multipleSelection && isDropdownOpen"
      #multiSearchInput
      class="dropdown-menu-search-input"
      [value]="searchText"
      placeholder="Search..."
      (input)="onSearchInput($event)"
      (click)="$event.stopPropagation()"
      (keydown)="onSearchInputKeydown($event)"
    />
    <div
      *ngFor="let item of filteredItems; let i = index"
      class="dropdown-item"
      [class.multi-select-item]="multipleSelection"
      [class.selected]="multipleSelection ? isItemChecked(item) : item === selectedItem"
      [class.non-selectable]="isItemNonSelectable(item)"
      [attr.aria-disabled]="isItemNonSelectable(item) ? 'true' : null"
      [title]="item"
      (click)="multipleSelection ? toggleMultiItem(item, $event) : onItemClick(item, $event)"
      (touchend)="multipleSelection ? onMultiItemTouchEnd(item, $event) : onItemTouchEnd(item, $event)"
    >
      <app-common-checkbox
        *ngIf="multipleSelection"
        [checked]="isItemChecked(item)"
        [disabled]="isItemNonSelectable(item)"
        (click)="$event.stopPropagation()"
        (checkedChange)="onMultiCheckboxChange(item)"
      ></app-common-checkbox>
      {{ getDisplayText(item) }}
    </div>
  </div>
</div>

<!-- Custom Type (Custom Dropdown) -->
<div *ngIf="filterType === 'custom'" class="dropdown-container custom-type"
     [class.from-advance-filter]="isCallingFromAdvanceDateFilter"
     [class.is-open]="isDropdownOpen"
     [class.has-selection]="selectedItem && !alwaysShowPlaceholder"
     [class.kebab-mode]="iconType === 'kebab'"
     [class.has-active-indicator]="hasActiveIndicator"
     [style.width]="width">
  <div class="dropdown-trigger" (click)="toggleDropdown(); $event.stopPropagation()">
    <span class="active-indicator-dot" *ngIf="hasActiveIndicator"></span>
    <span *ngIf="iconType !== 'kebab'" class="dropdown-text" [title]="alwaysShowPlaceholder ? placeholder : (selectedItem || placeholder)">
      {{ alwaysShowPlaceholder ? getDisplayText(placeholder) : (selectedItem ? getDisplayText(selectedItem) : getDisplayText(placeholder)) }}
    </span>
    <!-- Chevron Icon (default) -->
    <svg
      *ngIf="iconType === 'chevron'"
      class="dropdown-icon"
      [class.open]="isDropdownOpen"
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L6 6.5L11 1.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- Kebab Icon (3 vertical dots) -->
    <svg
      *ngIf="iconType === 'kebab'"
      class="dropdown-icon kebab-icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="4" r="1.5" fill="currentColor"/>
      <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
      <circle cx="10" cy="16" r="1.5" fill="currentColor"/>
    </svg>
  </div>

  <div #menuEl class="dropdown-menu common-dropdown-portal-menu"
       [ngStyle]="useFixedPosition ? menuStyle : {}"
       [style.background]="backGround" [style.border-color]="borderColor"
       [class.open]="isDropdownOpen"
       [class.fixed-position]="useFixedPosition"
       [class.align-right]="alignRight" [class.border]="borderColor!='none'">
    <div
      *ngFor="let item of items"
      class="dropdown-item"
      [class.selected]="item === selectedItem"
      [class.non-selectable]="isItemNonSelectable(item)"
      [style.border-radius]="item === selectedItem ? '12px' : ''"
      [attr.aria-disabled]="isItemNonSelectable(item) ? 'true' : null"
      [title]="item"
      (click)="onItemClick(item, $event)"
      (touchend)="onItemTouchEnd(item, $event)"
    >
      {{ getDisplayText(item) }}
    </div>
  </div>
</div>
